import type { FindOneVaultSearchResponseDTO } from '../../../../../shared/api/magellan/vaultSearch/dto';
import type {
  BidResponseDocumentSearchResult,
  WorkspaceDocumentSearchResult,
} from '../../../../../shared/entities/Search';

export function getUniqueDocumentIdString(
  result: FindOneVaultSearchResponseDTO['results'][number],
) {
  if (isBidResponseDocument(result)) {
    return `bidResponseDocument-${result.bidResponseDocumentId}`;
  } else if (isWorkspaceDocument(result)) {
    return `workspaceDocument-${result.workspaceDocumentId}`;
  }

  throw new Error('Invalid document type in result');
}

export function isBidResponseDocument(
  result: FindOneVaultSearchResponseDTO['results'][number],
): result is BidResponseDocumentSearchResult {
  return 'bidResponseDocumentId' in result;
}

export function isWorkspaceDocument(
  result: FindOneVaultSearchResponseDTO['results'][number],
): result is WorkspaceDocumentSearchResult {
  return 'workspaceDocumentId' in result;
}
